module.exports = __webpack_public_path__ + "static/media/RCS.bddb586d.jpg";